<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card flex">
      <i class="pi pi-cog title-card-icon"></i>
      <div>
        <p class="mb-0 text-3xl title">{{'model.templates' | transloco}}</p>
        <p>{{'menu.descriptions.templates' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="card">
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
          <div class="flex flex-column sm:flex-row justify-content-between">
            <div class="flex flex-column md:flex-row">
              <button
                *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)"
                [label]="'common.new' | transloco"
                pButton
                pRipple
                class="md:mr-2 p-button-primary mb-2 md:mb-0"
                routerLink="new"
                icon="pi pi-plus"
              ></button>
              <button
                *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)"
                [label]="'common.delete' | transloco"
                [disabled]="selected.length == 0"
                (click)="confirmAndDeleteSelected()"
                pButton
                pRipple
                class="p-button-danger mb-2 sm:mb-0"
                icon="pi pi-trash"
              ></button>
            </div>
            <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary"
                icon="pi pi-sliders-h"
              ></button>
            </div>
            <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
              <button
                [label]="'common.filters' | transloco"
                (click)="filtersVisible = !filtersVisible"
                pButton
                class="p-button-secondary filtersFilled"
                icon="pi pi-filter"
              ></button>
            </div>
          </div>
        </div>
        <p-table
          [(first)]="first"
          [(rows)]="rows"
          [(selection)]="selected"
          [value]="templates"
          [totalRecords]="totalTemplates"
          [responsive]="true"
          [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
          [paginator]="true"
          [rowsPerPageOptions]="[10,25,50]"
          [lazy]="true"
          (onLazyLoad)="onPageChange($event)"
          styleClass="p-datatable-striped"
          sortField="name"
        >
          <ng-template pTemplate="header">
            <tr>
              <th *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)" class="w-3rem"></th>
              <th pSortableColumn="name">
                {{'attribute.name' | transloco}}
                <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="type">
                {{'attribute.type' | transloco}}
                <p-sortIcon field="type"></p-sortIcon>
              </th>
              <th pSortableColumn="deviceCategory.name">
                {{'model.category' | transloco}}
                <p-sortIcon field="deviceCategory.name"></p-sortIcon>
              </th>
              <th pSortableColumn="tenant.name" *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                {{'model.tenant' | transloco}}
                <p-sortIcon field="tenant.name"></p-sortIcon>
              </th>
              <th pSortableColumn="creationDate">
                {{'attribute.creationDate' | transloco}}
                <p-sortIcon field="creationDate"></p-sortIcon>
              </th>
              <th pSortableColumn="updatedDate">
                {{'attribute.updatedDate' | transloco}}
                <p-sortIcon field="updatedDate"></p-sortIcon>
              </th>
              <th *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)" class="w-10rem">
                {{'common.actions' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-template>
            <tr *ngIf="!loadingTemplates" class="fadein">
              <td *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)">
                <span class="p-column-title bold">{{'common.select' | transloco}}</span>
                <p-tableCheckbox [value]="template"></p-tableCheckbox>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                <a [routerLink]="[template.uuid, 'details']">{{template.name}}</a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.type' | transloco}}</span>
                <p *ngIf="template.type === 'DEVICE'" class="text-right md:text-left">{{'model.device' | transloco}}</p>
                <p *ngIf="template.type === 'ASSET'" class="text-right md:text-left">{{'model.asset' | transloco}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'model.deviceCategory' | transloco}}</span>
                {{template.deviceCategory ? template.deviceCategory.name : ''}}
              </td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
                <span class="p-column-title bold">{{'model.tenant' | transloco}}</span>
                <a *ngIf="template.tenant" [routerLink]="['/management/tenants', template.tenant.uuid, 'details']">
                  {{template.tenant.name}}
                </a>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.creationDate' | transloco}}</span>
                <p class="text-right md:text-left">{{template.creationDate | customDate}}</p>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.updatedDate' | transloco}}</span>
                <p class="text-right md:text-left">{{template.updatedDate | customDate}}</p>
              </td>
              <td *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)">
                <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
                <div class="flex justify-content-end">
                  <button
                    [routerLink]="[template.uuid, 'edit']"
                    class="p-button-rounded btn-primary-light mr-2"
                    pButton
                    pRipple
                    icon="pi pi-pencil"
                  ></button>
                  <button
                    (click)="confirmAndDelete(template)"
                    class="p-button-rounded btn-danger-light"
                    pButton
                    pRipple
                    icon="pi pi-trash"
                  ></button>
                </div>
              </td>
            </tr>
            <tr *ngIf="loadingTemplates" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
              <td *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="'ROLE_SUPER_ADMIN' | userHasRole" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
              <td *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)" class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="totalTemplates == 0">
              {{'pagination.empty' | transloco}}
            </div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalTemplates > 0">
              {{'pagination.showing' | transloco}} {{first+1}}
              {{'pagination.to' | transloco}} {{(first+rows) >= totalTemplates ? totalTemplates : (first+rows)}}
              {{'pagination.of' | transloco}} {{totalTemplates}}
              {{(totalTemplates > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <div>
    <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12">
          <input
            [(ngModel)]="currentFilters.name"
            [focus]="filtersVisible"
            (keyup.enter)="filtersVisible = false; applyFilters()"
            appAutoFocus
            pInputText
            class="w-full"
            id="name"
            type="text"
          >
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="type">{{'model.type' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.types"
            [placeholder]="'select.generic' | transloco"
            [options]="types"
            [filter]="true"
            [styleClass]="'w-full'"
            id="type"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="deviceCategory">{{'model.category' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.deviceCategoryNames"
            [placeholder]="'select.generic' | transloco"
            [options]="deviceCategories"
            [filter]="true"
            [styleClass]="'w-full'"
            id="deviceCategory"
            display="chip"
            appendTo="body"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12" *ngIf="authGuard.superAdminRequired()">
        <div class="col-12 form-field">
          <label for="tenant">{{'model.tenant' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-multiSelect
            [(ngModel)]="currentFilters.tenantUuids"
            [placeholder]="'select.generic' | transloco"
            [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body"
            [options]="tenants"
            id="tenant"
            optionLabel="name"
            optionValue="uuid"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="creationRangeDates">{{'attribute.creationDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="creationRangeDates"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="creationRangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="updateRangeDates">{{'attribute.updatedDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar
            [(ngModel)]="updateRangeDates"
            [firstDayOfWeek]="1"
            [readonlyInput]="false"
            styleClass="w-full"
            id="updateRangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            appendTo="body"
            inputId="range"
          ></p-calendar>
        </div>
      </div>
      <div class="col-12">
        <p-button
          [label]="'common.filter' | transloco"
          [disabled]="!(
            currentFilters.name ||
            currentFilters.types ||
            currentFilters.deviceCategoryNames ||
            currentFilters.tenantUuids ||
            creationRangeDates ||
            updateRangeDates
          )"
          (onClick)="filtersVisible = false; applyFilters()"
          styleClass="p-button-primary mx-2 mt-2"
          type="button"
        ></p-button>
        <p-button
          [label]="'common.clear' | transloco"
          (click)="resetFilters(); filtersVisible = false;"
          styleClass="p-button-danger"
          type="button"
        ></p-button>
      </div>
    </div>
  </div>
</p-sidebar>
